<script setup>
import { computed } from 'vue';
import { channelImageFor } from 'dashboard/helper/channelIcon';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const channelImage = computed(() =>
  channelImageFor(props.inbox?.channel_type, props.inbox?.medium)
);
</script>

<template>
  <div class="flex items-center text-n-slate-11 text-xs min-w-0">
    <img
      v-if="channelImage"
      :src="channelImage"
      class="rounded-full size-3.5 ltr:mr-1 rtl:ml-1 flex-shrink-0"
    />
    <ChannelIcon
      v-else
      :inbox="inbox"
      class="size-3 ltr:mr-1 rtl:ml-1 flex-shrink-0"
    />
    <span class="truncate">
      {{ inbox.name }}
    </span>
  </div>
</template>
